var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-3{fill:#cedbf2;stroke:#cedbf2}.cls-5{fill:#e3e9f3;stroke:#e3e9f3}\n        "))), /*#__PURE__*/React.createElement("g", {
    id: "empty_48dp",
    transform: "translate(-632 -492)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "frame",
    transform: "translate(632 492)",
    style: {
      fill: "transparent"
    },
    d: "M0 0h48v48H0z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_296_empty_inbox_outline",
    "data-name": "#296_empty_inbox_outline",
    transform: "translate(526.59 444.85)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17834",
    "data-name": "Path 17834",
    d: "m148.01 111.88-6.619-9.105a1.454 1.454 0 0 0-1.178-.6h-19.986a1.454 1.454 0 0 0-1.178.6l-6.619 9.105v11.1a2.256 2.256 0 0 0 2.235 2.276h31.115a2.256 2.256 0 0 0 2.235-2.276z",
    transform: "translate(-.809 -38.305)",
    style: {
      fill: "#fafbfc"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_17835",
    "data-name": "Path 17835",
    className: "cls-3",
    d: "M144.973 124.432h-31.125a2.449 2.449 0 0 1-2.438-2.46v-10.987a.206.206 0 0 1 .039-.123l6.62-9.019a1.674 1.674 0 0 1 1.343-.683H139.4a1.674 1.674 0 0 1 1.343.683l6.62 9.019a.206.206 0 0 1 .039.123v10.991a2.449 2.449 0 0 1-2.429 2.456zm-33.153-13.38v10.924a2.041 2.041 0 0 0 2.032 2.05h31.121a2.041 2.041 0 0 0 2.032-2.05v-10.924l-6.579-8.968a1.266 1.266 0 0 0-1.016-.517h-19.994a1.266 1.266 0 0 0-1.016.517z",
    transform: "translate(0 -37.282)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_17836",
    "data-name": "Path 17836",
    d: "M147.994 149.042v11.1a2.256 2.256 0 0 1-2.235 2.276h-31.114a2.256 2.256 0 0 1-2.235-2.276v-11.1h9.631l.906 4.553a1.786 1.786 0 0 0 1.743 1.449h11.141a1.793 1.793 0 0 0 1.751-1.48l.837-4.534z",
    transform: "translate(-.793 -75.468)",
    style: {
      fill: "#e3e9f3"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17837",
    "data-name": "Path 17837",
    className: "cls-3",
    d: "M144.972 161.848h-31.124a2.461 2.461 0 0 1-2.438-2.483v-11.092a.205.205 0 0 1 .2-.207h9.633a.2.2 0 0 1 .2.166l.906 4.553a1.586 1.586 0 0 0 1.544 1.289h11.143a1.587 1.587 0 0 0 1.55-1.312l.837-4.534a.2.2 0 0 1 .2-.168h9.572a.205.205 0 0 1 .2.207v11.1a2.461 2.461 0 0 1-2.423 2.481zM111.82 148.48v10.889a2.051 2.051 0 0 0 2.032 2.069h31.119a2.051 2.051 0 0 0 2.029-2.069V148.48h-9.2l-.813 4.364a2 2 0 0 1-1.951 1.656H123.9a2 2 0 0 1-1.943-1.62l-.878-4.4z",
    transform: "translate(0 -74.698)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17838",
    "data-name": "Path 17838",
    className: "cls-3",
    d: "M134.075 190.36h-3.63c-.1 0-.185-.112-.185-.25s.083-.25.185-.25h3.63c.1 0 .185.112.185.25s-.083.25-.185.25z",
    transform: "translate(-15.51 -107.842)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17842",
    "data-name": "Path 17842",
    className: "cls-3",
    d: "M134.075 190.36h-3.63c-.1 0-.185-.112-.185-.25s.083-.25.185-.25h3.63c.1 0 .185.112.185.25s-.083.25-.185.25z",
    transform: "translate(9.827 -107.842)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17839",
    "data-name": "Path 17839",
    className: "cls-5",
    d: "M152.126 71.546a.414.414 0 0 1-.329-.166l-2.816-3.725a.414.414 0 1 1 .662-.5l2.814 3.725a.415.415 0 0 1-.331.664z",
    transform: "translate(-29.885 -10.184)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17840",
    "data-name": "Path 17840",
    className: "cls-5",
    d: "M227.351 71.588a.424.424 0 0 1-.25-.085.414.414 0 0 1-.081-.579l2.816-3.725a.414.414 0 0 1 .66.5l-2.814 3.725a.414.414 0 0 1-.331.164z",
    transform: "translate(-92.1 -10.227)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17841",
    "data-name": "Path 17841",
    className: "cls-5",
    d: "M196.7 60.12a.414.414 0 0 1-.414-.414v-5.142a.414.414 0 1 1 .828 0v5.142a.414.414 0 0 1-.414.414z",
    transform: "translate(-67.64)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.2846e06d.svg";
export { ForwardRef as ReactComponent };